module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/74.5b742708.png";